<template>
    <div
        :id="advanced.cssId"
        :class="['custom', advanced.cssClasses, responsiveClasses]"
        :style="style"
    >
        <div class="custom-inner"
            v-html="basic.html||''"
            :class="'el-'+details.id"
        >
        </div>
    </div>
</template>

<script>
import {getPadding} from "@/modules/page-editor/src/utils/props";

export default {
    name: 'EmailCustom',
    props: ['details'],
    computed: {
        basic() {
            return this.details.attributes.basic
        },
        advanced() {
            return this.details.attributes.advanced
        },
        responsive() {
            return this.details.responsive
        },
        responsiveClasses() {
            let c = '';
            if (!this.responsive) return '';
            if (!this.responsive.desktop) c = 'no-desktop';
            if (!this.responsive.mobile) c += ' no-mobile';
            if (!this.responsive.tablets) c += ' no-tablet';
            return c;
        },
        style() {
            return {
                margin: getPadding(this.basic.margin),
            };
        },
    }
}
</script>
